/**
 * @file The App component.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { ErrorService } from './core/error.service';
import { AuthenticationService } from './authentication.service';
import { Title } from '@angular/platform-browser';
import { SettingsService } from './settings.service';
import { AbstractBase } from './core/helpers/abstract-base';
/**
 * The root component of this application.
 */
var AppComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AppComponent, _super);
    /**
    * Creates an instance of AppComponent.
    * @param {ErrorService} errorService
    * @param {AuthenticationService} authenticationService
    * @param {*} document
    * @memberof AppComponent
    */
    function AppComponent(errorService, settingsService, authenticationService, titleService, document) {
        var _this = _super.call(this) || this;
        _this.errorService = errorService;
        _this.settingsService = settingsService;
        _this.authenticationService = authenticationService;
        _this.titleService = titleService;
        _this.document = document;
        // After refreshing we want to remove the iframe to
        // reduce memory consumption of the applicatin.
        _this.subscriptionPool.add(_this.authenticationService.removeRefreshIframe.subscribe(function () {
            _this.deleteSilentRefreshIFrame();
        }));
        // Set the title
        _this.titleService.setTitle(_this.settingsService.settings.frontend.title);
        return _this;
    }
    AppComponent.prototype.onFocus = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authenticationService.doSilentRefresh()];
                    case 1:
                        _a.sent(); // See #3529
                        return [2 /*return*/];
                }
            });
        });
    };
    // Delete the iframe used for the silent refresh method.
    AppComponent.prototype.deleteSilentRefreshIFrame = function () {
        var iframe = this.document.getElementById(this.authenticationService.getSilentRefreshIFrameName());
        if (iframe) {
            iframe.parentNode.removeChild(iframe);
        }
        else {
            console.warn('Trying to delete a non-existing silent refresh iframe...');
        }
    };
    return AppComponent;
}(AbstractBase));
export { AppComponent };
